module.exports = __webpack_public_path__ + "kudos_69.svg?dbe7d55b85c106152caff78984410424";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_69.svg
// module id = 171
// module chunks = 0